import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import Notiflix from "notiflix";

//ANT DESIGN IMPORTS
import {
  Row,
  Typography,
  Card,
  Spin,
  Form,
  Divider,
  Table,
  Col,
  Collapse,
  Tooltip,
  Button,
  Dropdown,
} from "antd";

//ANT DESIGN ICONS IMPORTS
import {
  SettingOutlined,
  LeftOutlined,
  FolderOpenOutlined,
  DownloadOutlined,
  UploadOutlined,
  CalculatorOutlined,
  HolderOutlined,
  DoubleRightOutlined,
} from "@ant-design/icons";

//PROJECT IMPORTS
import TopContent from "../../../../../components/layouts/TopContent";
import { BOM } from "../../../../../services/definedMethod";
import cnt from "../../../../../services/definedConstant";
import "../../../../../assets/styles/DatePicker.css";
import MainLayout from "../../../../../components/layouts/MainLayout";
import { apiConfig, labelConfig, staticConfig } from "../../../group.config";
import { rightAction } from "../../../../../redux/actions";
import {
  handleFlgStatus,
  AmountFormat,
  AccountFacility,
} from "../../../../../components/facilities/AccountFacility";
import {
  accountStatus,
  handleGsimApplicationDetailActionButtons,
} from "../../../../../components/facilities/GroupFacility";

const { Text, Title } = Typography;
const { Panel } = Collapse;

const DetailGroupGsim = (props) => {
  //DECLARED VARIABLES
  const { userData, rightAction } = props;
  const { session } = userData;
  const navigate = useNavigate();
  const { state } = useLocation();
  const [useForm] = Form.useForm();
  const [accountDetails, setAccountDetails] = useState([]);
  const [parentAccountDetails, setParentAccountDetails] = useState([]);
  const [applicationDetails, setApplicationDetails] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [menuProps, setMenuProps] = useState({
    items: [],
  });
  useEffect(() => {
    getDetailById();
    getGroupDetailById();
  }, []);

  const columns = [
    {
      title: "Customer Details",
      dataIndex: "displayName",
    },
    {
      title: "Savings Account",
      dataIndex: "accountNo",
    },
    {
      title: "Products",
      dataIndex: "productName",
    },
    {
      title: "Balance",
      dataIndex: "balance",
    },

    {
      title: "Status",
      dataIndex: "accountStatus",
    },
    {
      title: "Actions",
      render: (_, record) => (
        <>
          <Tooltip title={`View Account`}>
            <Button
              type="primary"
              icon={<FolderOpenOutlined />}
              shape="round"
              size="small"
              className="of-primaryBtnColor"
              disabled={!BOM.HasPermission("READ_SAVINGSACCOUNT")}
              onClick={() => (
                console.log(record),
                delete record.accounStatus,
                navigate("/detail-gsim-account", {
                  state: {
                    ...state,
                    childGSIMAccountId: record.id,
                  },
                })
              )}
            />
          </Tooltip>
        </>
      ),
    },
  ];

  const getDetailById = () => {
    const params = {
      parentGSIMAccountNo: state.accountNo,
    };
    const url = `${apiConfig.Groups}/${state.id}/gsimaccounts`;

    let body = {
      session,
      params,
    };
    setIsLoading(true);

    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
        setIsLoading(false);
      } else {
        const objDetail = res[0];
        setAccountDetails(objDetail);

        let tempGSIMSavingsArray = [];

        objDetail?.childGSIMAccounts?.forEach((element) => {
          tempGSIMSavingsArray.push({
            // ...element,
            key: element?.id,
            id: element?.id,
            productId: element?.productId,
            accountNo: element.accountNo ? element?.accountNo : "-",
            productName: element.productName ? element?.productName : "-",
            displayName: element.displayName ? element?.displayName : "-",
            balance: element.accountBalance ? element?.accountBalance : "-",

            accountStatus: handleFlgStatus(
              element?.status?.value,
              {},
              true,
              element
            ),
          });
        });

        setApplicationDetails(tempGSIMSavingsArray);

        /**
         * STOP LOADER
         */
        setIsLoading(false);
      }
    });
  };

  const getGroupDetailById = () => {
    const params = {
      associations: "all",
    };
    const url = `${apiConfig.SavingsAccounts}/${state.parentGSIMApplicationId}`;

    let body = {
      session,
      params,
    };
    setIsLoading(true);

    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
        setIsLoading(false);
      } else {
        const objDetail = res;
        // return;

        setParentAccountDetails(objDetail);

        let tempGSIMSavingsArray = [];

        objDetail?.childGSIMAccounts?.forEach((element) => {
          tempGSIMSavingsArray.push({
            // ...element,
            key: element?.id,
            id: element?.id,
            productId: element?.productId,
            accountNo: element.accountNo ? element?.accountNo : "-",
            productName: element.productName ? element?.productName : "-",
            displayName: element.displayName ? element?.displayName : "-",
            balance: element.accountBalance ? element?.accountBalance : "-",

            accountStatus: handleFlgStatus(
              element?.status?.value,
              {},
              true,
              element
            ),
          });
        });

        /**
         * ON CLICK ACTION MENU
         */
        setMenuProps({
          items: handleGsimApplicationDetailActionButtons(objDetail),
          onClick: (e) => {
            const item = handleGsimApplicationDetailActionButtons(
              objDetail
            ).find((element) => element.key === e.key);
            if (item) {
              //ROUTE REDIRECTING ACTIONS
              return navigate(item.route, {
                state: {
                  ...state,
                  // accountNo: objDetail?.accountNo,
                  actionLabel: item.label,
                },
              });
              // }
            }
          },
        });
        /**
         * ACTIVATE DELETE RIGHT BUTTON ACTION
         */
        // if (
        //   objDetail?.status?.value.toLowerCase() ===
        //   accountStatus.submittedAndPending
        // ) {
        //   rightAction(cnt.RIGHT_DELETE_BTN);
        // }

        /**
         * STOP LOADER
         */
        setIsLoading(false);
      }
    });
  };

  const handleOnDelete = () => {
    let action = "Delete Account  ";
    let accountNo = accountDetails.accountNo;

    Notiflix.Confirm.show(
      "Are you sure?",
      action + accountNo,
      "Yes",
      "No",

      function () {
        setIsLoading(true);
        const url = `${apiConfig.SavingsAccounts}/${state.id}`;
        let body = {
          session,
          method: "DELETE",
          session,
        };
        BOM.FetchReqAction(body, url, (err, res) => {
          if (err) {
            BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
            //STOP LOAD
            setIsLoading(false);
          } else {
            BOM.AlertMsg(cnt.SUCCESS, labelConfig.deleteSavingsGrpMsg);
            navigate("/detail-group", {
              state: { id: state.mainGrpId },
            });
            //STOP LOAD
            setIsLoading(false);
          }
        });
      },

      function () {
        // No button
      }
    );
  };

  function backOnClick() {
    navigate("/detail-group", { state: state });
  }

  return (
    <MainLayout isEnableRightSidebar={true} onDelete={handleOnDelete}>
      {/* PART 1  IMPORT TOP CONTENT*/}
      <TopContent
        pageTitle={labelConfig.gsimApplicationDetail}
        pageItems={staticConfig.gsimApplicationDetailBreadcrumbItems}
      />

      <Spin spinning={isLoading} size="large">
        <Card
          headStyle={{ borderBottomWidth: 0 }}
          style={{
            boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
            borderRadius: 20,
          }}
        >
          <Row
            style={{
              alignContent: "center",
              //   width: "8%",
            }}
          >
            <Button
              icon={<LeftOutlined />}
              type="text"
              style={{
                marginTop: "auto",
                marginBottom: "auto",
              }}
              onClick={backOnClick}
            >
              <Text
                style={{
                  marginTop: "auto",
                  marginBottom: "auto",
                  fontSize: 15,
                }}
              >
                Back
              </Text>
            </Button>
          </Row>
          {/* <Divider /> */}
          <Divider orientation="left" orientationMargin="0">
            <Title level={5} style={{ margin: 0, marginBottom: 0 }}>
              {`Account No: ${state.accountNo}`}
            </Title>
          </Divider>
          <Form
            form={useForm}
            layout="vertical"
            style={{ paddingTop: 20, marginBottom: 50 }}
          >
            {/* <Row>
              <Title level={4} style={{ margin: 0, marginBottom: 0 }}>
                {labelConfig.generalInfo}
              </Title>
            </Row>
            <Divider style={{ marginTop: 10 }} /> */}
            <Row>
              <Col span={12} style={{ padding: "0px 8px" }}>
                <Dropdown.Button
                  menu={menuProps}
                  icon={<SettingOutlined />}
                  placement="topLeft"
                >
                  Actions
                </Dropdown.Button>
              </Col>
            </Row>
            <Divider style={{ marginTop: 10 }} />
            <Table
              // rowSelection={{
              //   type: "radio",
              //   onChange: onSelectItemAction,
              // }}
              columns={columns}
              dataSource={applicationDetails}
              bordered
              pagination={{
                position: "bottomCentre",
                // pageSize: tableCount,
              }}
            />
          </Form>
        </Card>
      </Spin>
    </MainLayout>
  );
};

const mapStateToProps = (state) => ({
  userData: state.AuthenticationData.userData,
});
const mapDispatchToProps = { rightAction };

export default connect(mapStateToProps, mapDispatchToProps)(DetailGroupGsim);
